var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game"},[(_vm.gameId)?[_c('ActiveIndividualGame',{attrs:{"playerKey":_vm.playerKey,"gameId":_vm.gameId}})]:_vm._e(),(_vm.error)?[_c('div',{staticClass:"text-center"},[_vm._v(" Game Not Found ")])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }